import(/* webpackMode: "eager", webpackExports: ["RegisterComponent"] */ "/vercel/path0/app/(auth)/register/components/RegisterComponent.tsx");
